import { ChartReaderPage } from 'features/chartReader/components/ChartReaderPage';
import { Navigate, Route, Routes } from 'react-router-dom';

export function ChartReaderPageRoutes() {
    return (
        <Routes>
            <Route path='/*' element={<Navigate to='.' replace />} />
            <Route path='/' element={<ChartReaderPage />} />
        </Routes>
    );
}
